import React from 'react';
import { observer } from 'mobx-react-lite';

interface HeaderPropsType {
    title: string;
    description?: string;
}

export const Header = observer(({ title, description }: HeaderPropsType) => {
    return (
        <header className='font-tertiary'>
            <h2 className='text-[1rem] font-semibold text-foreground leading-7 m-0 mb-1'>{title}</h2>
            {description === undefined ? null : (
                <p className='text-sm font-normal leading-5 text-muted-foreground mt-3 mb-0'>{description}</p>
            )}
        </header>
    );
});
